import React, { useEffect } from 'react'
import SelectGuestItem, { GuestType } from './SelectGuestItem'
import clsx from 'clsx'
import BasicButton from '../ui/BasicButton'
import { setAdults, setChildren, setInfants, setPets, setGuestCount } from '../../redux/slices/property'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { VIEW } from '../../constant'

export const GUEST_TYPE: GuestType[] = ['adult', 'child', 'infant', 'pet']

interface Props {
  personCapacity: number
  maxPet?: number
  allowZeroAdult?: boolean
  updateView: (_v: string) => void
}

const SelectGuest: React.FC<Props> = ({ personCapacity, maxPet, allowZeroAdult, updateView }) => {
  const dispatch = useAppDispatch()
  const { adults, children, infants, guestCount } = useAppSelector((state) => state.property)

  useEffect(() => {
    // setGuestInfo((prevState) => ({ ...prevState, adults, children, infants }))
    dispatch(setGuestCount({ adults, children, infants }))
  }, [adults, children, infants])

  const onChangeGuestInfo = (data: any) => {
    dispatch(setGuestCount({ ...data }))
  }
  const handleApply = () => {
    dispatch(setAdults(guestCount.adults))
    dispatch(setChildren(guestCount.children))
    dispatch(setInfants(guestCount.infants))
    dispatch(setPets(guestCount.pets))
    updateView(VIEW.DETAIL)
  }

  return (
    <>
      <div className={'h-full'}>
        {GUEST_TYPE.map((type, index) => {
          return (
            <SelectGuestItem
              index={index}
              key={type}
              type={type}
              hasBorderBot={index !== GUEST_TYPE.length - 1}
              personCapacity={personCapacity}
              allowZeroAdult={allowZeroAdult}
              maxPet={maxPet}
              guestCount={guestCount}
              onChangeGuestInfo={onChangeGuestInfo}
            />
          )
        })}
        <div className={`dtravel-flex-between items-center`} style={{ paddingTop: 16, paddingBottom: 0 }}>
          <p className={'dtravel-inter-400 dtravel-text-14-20 dtravel-neutral-600'}>
            This listing has a maximum of {personCapacity > 16 ? '16+' : personCapacity}{' '}
            {personCapacity > 1 ? 'guests' : 'guest'}, not including infants. Pets are{' '}
            {maxPet ? 'allowed' : 'not allowed'}.
          </p>
        </div>
      </div>

      {/*---Footer---*/}
      <div
        className={clsx(
          'dtravel-absolute bottom-0 left-0 dtravel-w-full h-[72px] shadow-xl bg-white',
          'px-[24px] py-[16px]',
          'flex dtravel-gap-8 justify-end'
        )}
        style={{ zIndex: 1200 }}
      >
        <BasicButton variant={'contained'} color={'black'} clases={'w-auto'} size={'lg'} onClick={handleApply}>
          Apply
        </BasicButton>
      </div>
    </>
  )
}

export default SelectGuest
